import React from 'react';
import Detail from '../../parameters/crew-lookups/Detail';
import Form from '../../parameters/crew-lookups/Form';
import { CrewLookupListPanel } from '../../parameters/crew-lookups/List';
import type { CrewLookupRouteOptions } from '../../parameters/crew-lookups/config';

/** Same manning-agent records as crew parameters, opened from Users & access. */
export const MANNING_AGENTS_ACCESS_ROUTES: CrewLookupRouteOptions = {
  list: '/admin/manning-agents',
  recordBase: '/admin/manning-agents',
  permissionModuleKey: 'users',
};

export const ManningAgentsList: React.FC = () => (
  <div className="flex h-full min-h-0 flex-col">
    <CrewLookupListPanel kind="manning-agents" routes={MANNING_AGENTS_ACCESS_ROUTES} />
  </div>
);

export const ManningAgentsForm: React.FC = () => (
  <Form kind="manning-agents" routes={MANNING_AGENTS_ACCESS_ROUTES} />
);

export const ManningAgentsDetail: React.FC = () => (
  <Detail kind="manning-agents" routes={MANNING_AGENTS_ACCESS_ROUTES} />
);
